module.exports = __webpack_public_path__ + "assets/images/caixa_carta1_0ca374e7fc1dd1a582391294daa77489.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page-eight/caixa_carta1.png
// module id = 239
// module chunks = 0